export const typeList = [
  { id: "day", name: "Day" },
  { id: "date", name: "Date" },
];
